export const PRODUCTS = [
  {
    id: "prod-mcpolish",
    slug: "mcpolish",
    name: "MCPOLISH",
    display_name: "MCPolish",
    category: "mcp-tools",
    tagline: "Static linter for MCP servers",
    description:
      "mcpolish is a static linter for Model Context Protocol servers. It catches vague, colliding, or misleading tool descriptions before agents pick the wrong tool. In a study of 10,831 public MCP servers (Wang et al., February 2026), bad descriptions caused agents to pick the wrong tool 52 percentage points more often. That paper catalogued 18 specific problems; mcpolish detects 23 of them, before you ship.",
    features: [
      "23 lint rules across schema, naming, description, consistency, security",
      "Sub-second scans, zero external calls in the default engine",
      "Five output formats: terminal, JSON, SARIF, GitLab Code Quality, GitHub PR comments",
      "Two-tier auto-fix: safe edits by default, risky renames behind --unsafe-fix",
      "Three optional LLM-judged rules for the cases static heuristics miss",
    ],
    status: "available",
    image_url: "/images/melonai/agentos.svg",
    docs_url: "/docs/mcpolish/",
    links: {
      pypi: "https://pypi.org/project/mcpolish",
      github: "https://github.com/vtensor/mcpolish",
      docs: "/docs/mcpolish/",
    },
  },
  {
    id: "prod-memnex",
    slug: "memnex",
    name: "MEMNEX",
    display_name: "Memnex",
    category: "memory",
    tagline: "Cross-channel permanent memory for AI agents",
    description:
      "Memnex is a memory service for conversational AI agents. When the same user moves from a phone call to WhatsApp to web chat, every agent on every channel already knows what happened on the previous channels: same name, same open issues, same preferences, same history. It plugs in over the Model Context Protocol so any MCP-compatible agent (Claude Desktop, Cursor, LangGraph, CrewAI, your own runtime) can use it without writing integration code.",
    features: [
      "MCP-native: works with any MCP-compatible agent runtime",
      "Three layers of memory: short-term, long-term episodic, semantic facts",
      "Pluggable storage: Redis, Postgres, Qdrant, in-memory",
      "Semantic search, hallucination detection via memory_trace",
      "GDPR purge, HMAC-signed audit ledger, PII masking",
    ],
    status: "available",
    image_url: "/images/melonai/voiceflow.svg",
    docs_url: "/docs/memnex/",
    links: {
      pypi: "https://pypi.org/project/memnex",
      github: "https://github.com/vtensor/memnex",
      docs: "/docs/memnex/",
    },
  },
  {
    id: "prod-evalsig",
    slug: "evalsig",
    name: "EVALSIG",
    display_name: "EvalSig",
    category: "evals",
    tagline: "Statistical rigor for frontier AI evaluation",
    description:
      "Frontier labs ship model updates on eval deltas of 1 to 3 percent without a principled way to tell signal from noise. EvalSig sits between your eval harness (lm-eval, HELM, internal pipelines) and your release decision, applying bootstrap resampling, permutation testing, and minimum-detectable-effect analysis to every benchmark run. One line of Python or one CLI call in CI gates model promotion the way unit tests gate code merges.",
    features: [
      "Bootstrap resampling + permutation tests on every run",
      "MDE analysis: tells you how many samples you actually need",
      "Pure NumPy/SciPy core, zero GPU dependencies",
      "Adapters for lm-eval, HELM + plugin API for internal evals",
      "Run-history store: flakiness trends, regression patterns, power decay",
    ],
    status: "available",
    image_url: "/images/melonai/datamind.svg",
    docs_url: "/docs/evalsig/",
    links: {
      pypi: "https://pypi.org/project/evalsig",
      github: "https://github.com/vtensor/evalsig",
      docs: "/docs/evalsig/",
    },
  },
];
